import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import ResetPassword from 'yoda-checkout-components/lib/components/ResetPassword/ResetPassword';
import { setGlobalErrorHandler } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import splunkLogsActions from 'yoda-checkout-components/lib/actions/SplunkLogsActions';
import withBoundaryError from 'yoda-checkout-components/lib/components/ErrorBoundary/ErrorBoundaryHOC';
import * as checkoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import { getCartDetails } from '../../../actions/GetCartDetailsAction';

const section = 'RESET_PASSWORD';
let isPageLoadSuccessActionFired = false;
export class ResetPasswordPage extends Component {
    static propTypes = {
        featureFlags: PropTypes.objectOf(PropTypes.object),
        actions: PropTypes.objectOf(PropTypes.func),
        cartDetails: PropTypes.array,
    };

    static defaultProps = {
        featureFlags: {},
        actions: {},
        cartDetails: [],
    };

    constructor() {
        super();
        this.errorSubscription = () => {};
    }

    // eslint-disable-next-line react/no-deprecated, react/sort-comp
    componentWillReceiveProps(nextProps) {
        /* istanbul ignore else */
        if (
            !isEmpty(nextProps.cartDetails.data) &&
            !isEqual(this.props.cartDetails, nextProps.cartDetails)
        ) {
            isPageLoadSuccessActionFired = true;
            this.props.actions.pageLoadSuccessAnalyticsAction('checkout login');
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        // DA => Page load handler for forgot password
        if (get(this.props.cartDetails, 'data') && !isPageLoadSuccessActionFired) {
            isPageLoadSuccessActionFired = true;
            this.props.actions.pageLoadSuccessAnalyticsAction('checkout reset password');
        } else {
            this.props.actions.getCartDetails();
        }
    }

    componentDidMount() {
        const enableGlobalErrorLogs = get(
            this.props.featureFlags,
            'splunkLogs.enableGlobalErrorLogs'
        );
        /* istanbul ignore next */
        if (enableGlobalErrorLogs) {
            this.errorSubscription = setGlobalErrorHandler(
                section,
                this.props.actions.logGlobalError
            );
        }
    }

    componentWillUnmount() {
        this.errorSubscription();
    }

    render() {
        return (
            <Layout>
                <ResetPassword />
            </Layout>
        );
    }
}

const mapStateToProps = (state) => {
    const featureFlags = get(state, 'context.featureFlags');
    const { cartDetails } = state;
    return {
        featureFlags,
        cartDetails,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        { ...splunkLogsActions, ...checkoutAnalyticsAction, getCartDetails },
        dispatch
    ),
});

export default withBoundaryError(
    connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage),
    section
);
